import { api, ApiError } from "./api";
import type { Capabilities } from "./types";

// Split-hostname auth model per the Dyno plan (Key Design Decision #2):
// - dyno.overdrive.rocks        → public, session-cookie / API-key auth only (CF Access disabled)
// - admin-dyno.overdrive.rocks  → CF Access required; admins get JWT
//
// Single-level subdomain for the admin UI (not admin.dyno.*) because
// Cloudflare's free Universal SSL cert only covers one level of wildcard.
// The frontend detects which host it's running on and gates admin UI accordingly.

export const IS_ADMIN_HOST = (() => {
  if (typeof window === "undefined") return false;
  if (import.meta.env.VITE_DEMO === "1") return true; // demo: expose admin routes
  return window.location.hostname.split(".")[0] === "admin-dyno";
})();

export async function fetchCapabilities(): Promise<Capabilities | null> {
  try {
    return await api.get<Capabilities>("/api/capabilities", { skipAuthRedirect: true });
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null;
    throw err;
  }
}
